import React from 'react'

import {Invitation404Form} from '../templates';
import {PageTemplate} from '../atoms';

export default function Invitation404Page({history}) {
  const {language} = history.location.state;
  return (
    <PageTemplate>
      <Invitation404Form language={language}/>
    </PageTemplate>
  )
}
